import styled from 'styled-components';

export const StyledContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: var(--primary-color);
  color: #fff;
  position: fixed;
  top: 0;
  left: 0;
`;

export const StyledContentContainer = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  padding: 14px;
  margin: 50vh auto 0;
  transform: translateY(-60%);
  align-items: center;
  a {
    color: #d5e7f8;
    font-weight: 500;
  }
  a:hover {
    color: #d5e7f8;
    font-weight: 500;
  }
`;

export const StyledHeading = styled.div`
  font-size: 24px;
  line-height: 40px;
  font-weight: 500;
`;

export const StyledPIHeading = styled.div`
  font-size: 20px;
  line-height: 28px;
  font-weight: 500;
`;

export const StyledLineBreak = styled.div`
  width: 240px;
  height: 1px;
  background-color: rgba(251, 251, 251, 0.2);
  margin: 20px auto;
`;

export const StyledStatusText = styled.div`
  font-size: 14px;
  line-height: 20px;
  max-width: 60ch;
`;

export const StyledVersionText = styled.div`
  font-size: 10px;
  color: rgba(251, 251, 251, 0.4);
`;
